import { ControlUser } from './controlUser';
import {Deserializable} from './deserializable';


export class OwnerData implements Deserializable {

  ownerUid: string;
  owner: ControlUser;
  name: string;
  logoUrl: string;


  // context (optional)
  
  // createdAt (optional)
  
  // id (optional)
    
  // logoUrl (optional)

  // name (optional)

  // owner (optional)

  // ownerUid (optional)
  
  // updateAt (optional)
  

  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }
}
